export default {seo:{title:'Sponsorship',description:null},title:'Sponsorship'};